"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const RemoveToken = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M23 12c0 2.315-.715 4.463-1.936 6.235l-1.444-1.444A9 9 0 007.209 4.38L5.765 2.937A10.95 10.95 0 0112 1c6.075 0 11 4.925 11 11zm-3 0a7.964 7.964 0 01-1.108 4.064L13.01 10.18a.25.25 0 01.24-.181h2.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25h-4.922L7.936 5.108A8 8 0 0120 12zm-2.343 5.657L13 13l-2-2-1-1-1.927-1.927-1.73-1.73-.707-.707-1.414-1.414L2.1 2.1.686 3.515l2.25 2.25A10.95 10.95 0 001 12c0 6.075 4.925 11 11 11 2.315 0 4.463-.715 6.235-1.936l2.25 2.25 1.415-1.415-2.122-2.12-1.414-1.415-.707-.707zm-1.593 1.235A8 8 0 015.108 7.936L4.38 7.21A9 9 0 0016.791 19.62l-.727-.728zM13 15.83v.921a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-2.921l2 2z"
      }
    )
  );
};
export default RemoveToken;
